import { MailProtocolWizardActionTypes, MailProtocolWizardReduxState, SET_INITIAL_STATE, UPDATE_MAIL_PROTOCOL_WIZARD_STATE } from './types'



const setInitialState = (): MailProtocolWizardActionTypes => {
    return {
        type: SET_INITIAL_STATE,
    }
}

const updateMailProtocolWizardState = (newState: Partial<MailProtocolWizardReduxState>): MailProtocolWizardActionTypes => {
    return {
        type: UPDATE_MAIL_PROTOCOL_WIZARD_STATE,
        payload: newState
    }
}


export default {
    setInitialState, updateMailProtocolWizardState
}